module.exports = __webpack_public_path__ + "img/excmark.bf1d33b8.svg";